import moment from "moment";

export function useWorkingDays() {

  const nextWorkingDay = () => {
    const today = moment();
    const day = today.isoWeekday();
    if (day === 5) return today.clone().add(3, 'day');
    if (day === 6) return today.clone().add(2, 'day');
    if (day === 7) return today.clone().add(1, 'day');
    return today.clone().add(1, 'day');
  };

  const isCritico = (deliveryDate) => {
    return deliveryDate.isSame(moment(), 'day') || deliveryDate.isBefore(moment(), 'day');
  };

  const isPrioritario = (deliveryDate) => {
    const today = moment();
    const nextWorkingDayDate = nextWorkingDay();
    
    if (today.isoWeekday() === 5) {
      const saturday = today.clone().add(1, 'day');
      const sunday = today.clone().add(2, 'day');
      const monday = today.clone().add(3, 'day');
      return deliveryDate.isSame(saturday, 'day') || 
             deliveryDate.isSame(sunday, 'day') || 
             deliveryDate.isSame(monday, 'day');
    }
    
    return deliveryDate.isSame(nextWorkingDayDate, 'day');
  };

  const isFuture = (deliveryDate) => {
    return deliveryDate.isAfter(nextWorkingDay(), 'day');
  };

  const getWeekendLabel = (dateString) => {
    const date = moment(dateString, "DD/MM/YYYY");
    const dayOfWeek = date.isoWeekday();
    
    switch (dayOfWeek) {
      case 6: return "(SAB)";
      case 7: return "(DOM)";
      case 1: return "(LUN)";
      default: return "";
    }
  };

  const isTodayFriday = () => {
    return moment().isoWeekday() === 5;
  };

  const isSaturday = (date) => {
    return date.isoWeekday() === 6;
  };

  const isSunday = (date) => {
    return date.isoWeekday() === 7;
  };

  const isMonday = (date) => {
    return date.isoWeekday() === 1;
  };

  return {
    nextWorkingDay,
    isCritico,
    isPrioritario,
    isFuture,
    getWeekendLabel,
    isTodayFriday,
    isSaturday,
    isSunday,
    isMonday
  };
}
